import { render, staticRenderFns } from "./PatchFirmwareImage.vue?vue&type=template&id=72b4c143&scoped=true&"
import script from "./PatchFirmwareImage.vue?vue&type=script&lang=ts&"
export * from "./PatchFirmwareImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4c143",
  null
  
)

export default component.exports